import { useMutation, useQueryClient } from "@tanstack/react-query";
import updateScheduledReport from "api/scheduledReports/updateScheduledReport";
import handleInvalidateError from "helpers/handleInvalidateError";
import { phaseIdKey } from "queryKeys/phase";
import { phaseRulesWithCampaignId } from "queryKeys/phaseRulesKey";
import { toast } from "react-toastify";

export default function useUpdateScheduledReportMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateScheduledReport,
    onSuccess: (data) => {
      toast.success(data.message || "Scheduled report updated successfully.");

      queryClient
        .invalidateQueries({ queryKey: phaseRulesWithCampaignId() })
        .catch(handleInvalidateError);
      queryClient.invalidateQueries({ queryKey: phaseIdKey() }).catch(handleInvalidateError);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });
}
